import EmployeeDialog from './EmployeeDialog';

export default EmployeeDialog;
